import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_branch_RowClass} from '../../dbschema/bl_fi_mst_branch.model';

export class BranchHeaderContainerModel extends BaseContainerModel {
  bl_fi_mst_branch: bl_fi_mst_branch_RowClass = new bl_fi_mst_branch_RowClass();
}
